/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tryadjustingyoursearchquery4Inputs */

const en_tryadjustingyoursearchquery4 = /** @type {(inputs: Tryadjustingyoursearchquery4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try adjusting your search query`)
};

const de_tryadjustingyoursearchquery4 = /** @type {(inputs: Tryadjustingyoursearchquery4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe deine Suchanfrage an`)
};

/**
* | output |
* | --- |
* | "Try adjusting your search query" |
*
* @param {Tryadjustingyoursearchquery4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const tryadjustingyoursearchquery4 = /** @type {((inputs?: Tryadjustingyoursearchquery4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tryadjustingyoursearchquery4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tryadjustingyoursearchquery4(inputs)
	return de_tryadjustingyoursearchquery4(inputs)
});
export { tryadjustingyoursearchquery4 as "tryAdjustingYourSearchQuery" }